import React, {useEffect, useState} from 'react';

import {LogoIcon} from "../icons/LogoIcon";
import {HardRefreshWarning} from "../../elements/HardRefreshWarning";


import {inAppEventsHub} from "../../../volatile/InAppEventsHub";


import './Loading.css';


export const Loading = () => {
    const [isWarningShown, setIsWarningShown] = useState(false);

    useEffect(() => {
        const handleHardRefreshWarning = () => {
            setIsWarningShown(true);
        }
        inAppEventsHub.subscribe('HardRefreshWarning', handleHardRefreshWarning);
        return () => {
            inAppEventsHub.unsubscribe('HardRefreshWarning', handleHardRefreshWarning)
        }
    }, []);


    return (
        <div
            className={'Loading'}
        >
            <div className="Loading__icon">
                <LogoIcon colorOverwritten={true} size={null}/>
            </div>
            <div className="Loading__line">
                <div className="pm-liner-loading"></div>
            </div>
            {
                isWarningShown
                    ? <HardRefreshWarning className="Loading__warning"/>
                    : null
            }
        </div>
    )
}